<template>
  <div>
    <b-row>
      <b-col cols="12">
        <Search
          :allowCollapse="false"
          :url="url"
          :title="$lang.profileLang.inquiryPerson"
          :allowFields="
            !!mode
              ? $lang.profileLang.inquiry_fields
              : $lang.profileLang.inquiry_list
          "
          config="inquiry"
          addModalSize="lg"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :allowEdit="false"
          :visibleAccordion="true"
          :isImportExcelTooltip="$lang.import_inquiry_file"
          :visibleAdd="!!mode"
          :isImportExcel="!mode"
          @importExcel="importExcelModal"
          ref="searchInquiry"
          :dynamicButtons="dynamicButtons"
          :parentPermissions="parentPermissions"
          :showAlert="false"
          colorAlert="success"
          titleAlert=""
          :hiddenFields="hiddenFields"
          :remove_item="remove_item"
          @getPermisson="updatePermissions"
        >
          <template slot="addModal" slot-scope="search">
            <AddInquiry
              @modal-end-up="closeAddModal(search)"
              :code="person_code"
            />
          </template>
        </Search>

        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="editInquiryModal"
          size="xl"
          ok-only
          hide-footer
          hide-header
        >
          <EditInquiry
            :code="person_code"
            :itemId="editInquiryItemId"
            @modal-end-up="closeEditInquiryModal"
          />
        </b-modal>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="isImportFile"
          :title="$lang.add_user_role_tooltip"
          size="xl"
          hide-header
          hide-footer
        >
          <ShowCardUpload
            :url="uploadExcelUrl"
            :showAlert="exampleFileLink"
            @closeModal="isImportFile = false"
            @getItems="getItems"
          />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddInquiry from "./addInquiry";
import EditInquiry from "./editInquiry";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "search-inquiry",
  components: {
    Search,
    AddInquiry,
    EditInquiry,
    ShowCardUpload,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      required: false,
    },
    mode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hiddenFields: ["updated_by", "updated_at"],
      dynamicButtons: [
        {
          id: 0,
          name: "edit",
          click: this.showEditInquiryModal,
        },
        {
          id: "1",
          name: "view",
          click: this.showEditInquiryModal,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      editInquiryItemId: null,
      editInquiryModal: false,
      person_code: null,
      isImportFile: false,
    };
  },
  computed: {
    url() {
      return this.mode
        ? generateApiUrl(["profile", "person_inquiry"], [this.code])
        : generateApiUrl(["profile", "inquiry_list"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["profile", "import_inquiry"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_inquiry.xlsx`;
      return `<div class='text-center font-weight-bold'>
      <p>${this.$lang.import_inquiry}</p>
      <a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    closeAddModal(search) {
      search.close();
      this.$refs.searchInquiry.getItems();
    },
    getItems() {
      this.$refs.searchInquiry.getItems();
      this.isImportFile = false;
    },
    importExcelModal() {
      this.isImportFile = true;
    },
    showEditInquiryModal(item) {
      this.person_code = item.person ? item.person.code : this.code;
      this.editInquiryItemId = item.id;
      this.editInquiryModal = true;
    },
    closeEditInquiryModal(getItems = false) {
      this.editInquiryItem = null;
      this.editInquiryModal = false;
      getItems && this.$refs.searchInquiry.getItems();
    },
    updatePermissions(data) {
      this.$emit("getPermissions", data);
    },
    async remove_item(item) {
      try {
        const code = pathOr(null, ["person", "code"], item);
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(
          ["profile", "person_inquiry_id"],
          [code, id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
  created() {
    this.person_code = this.code;
  },
};
</script>
